import request from "../request";

/**
 * Описание типа ценовой зоны
 * @typedef {Object} Zone
 * @property {Number} zone
 * @property {Number} price
 * @property {String} color
 * @property {String} name
 * @property {Number} free
 * @property {Number} all
 */

/**
 * Описание типа цены
 * @typedef {Object} Price
 * @property {String} id
 * @property {Number} z
 * @property {Number} c
 */

/**
 * Получение всех данных мерпориятия
 * нужен например когда надо открыть мероприятие на модалке на афише (как Коми Банди)
 * @return {Promise}
 */
export const getEventById = eventId => {
	return request({
		url: "/event/get-event-by-id",
		addCSRFToken: true,
		needOverlay: false,
		data: {
			event_id: eventId,
		},
	});
};

/**
 * Описание ответа получения свг и цен
 * @typedef {Object} PlacesParamsItem
 * @property {string} sid
 * @property {number} view_id
 * @property {string} name
 * @property {string} sector
 * @property {string} row
 * @property {string} col
 */

/**
 * Описание ответа получения свг и цен
 * @typedef {Object} GetSvgPlacesResponse
 * @property {string} version
 * @property {string} svg
 * @property {Object<string, string[]>} places - список сидов сгруппированных по зоне
 * @property {Zone[]} zones
 * @property {Object<string, PlacesParamsItem>} places_params
 */

/**
 * Получение svg мероприятия и цены
 * @return {Promise<GetSvgPlacesResponse>}
 */
export function getSvgPlaces({eventId, viewId}) {
	return request({
		url: "/event/get-svg-places",
		addCSRFToken: true,
		needOverlay: false,
		data: {
			event_id: eventId,
			view_id: viewId,
		},
	});
}

/**
 * Описание объекта свободных или занятых мест
 * @typedef {Object} PlacesType
 * @property {('busy' | 'free')} type
 * @property {Price[]} values
 */

/**
 * Получение svg мероприятия и цены
 * @return {Promise<{ places: PlacesType, zones: Zone[], places_params: Object<string, PlacesParamsItem> }>}
 */
export const getActualPlaces = ({eventId, viewId, clearCache}) => {
	return request({
		url: "/event/get-actual-places",
		addCSRFToken: true,
		needOverlay: false,
		data: {
			event_id: eventId,
			view_id: viewId,
			clear_cache: clearCache,
		},
	});
};

/**
 * Получение версии хранения svg плана
 * @return {Promise}
 */
export const getPlacesHash = ({eventId, viewId}) => {
	return request({
		url: "/event/get-places-hash",
		addCSRFToken: true,
		needOverlay: false,
		data: {
			event_id: eventId,
			view_id: viewId,
		},
	});
};

/**
 * Получение svg мероприятия и цены
 * @return {Promise}
 */
export const getSvgPrices = ({eventId, viewId}) => {
	return request({
		url: "/event/get-svg-prices",
		addCSRFToken: true,
		data: {
			event_id: eventId,
			view_id: viewId,
		},
	});
};

/**
 * Получение Цены мероприятия
 * @param params {Object}
 * @param params.eventId {Number}
 * @param params.viewId {Number}
 * @return {Promise<{ zones: Array<Zone>, prices: Array<Price>, places_params: Object<string, PlacesParamsItem> }>}
 */
export function getPrices({eventId, viewId}) {
	return request({
		url: "/event/get-prices",
		addCSRFToken: true,
		data: {
			event_id: eventId,
			view_id: viewId,
		},
	});
}

/**
 * Получение ценовых зон мероприятия
 * @return {Promise<{ zones: Object.<number, Zone> }>}
 */
export const getZones = ({eventId}) => {
	return request({
		url: "/event/get-zones",
		needOverlay: false,
		type: "GET",
		data: {
			event_id: eventId,
		},
	});
};

export const getZonesGroupedByViews = ({eventId}) => {
	return request({
		url: "/event/get-zones-grouped-by-views",
		needOverlay: false,
		addCSRFToken: true,
		data: {
			event_id: eventId,
		},
	});
};

export const getPlaces = ({eventId}) => {
	return request({
		url: "/event/get-places",
		needOverlay: false,
		type: "GET",
		data: {
			event_id: eventId,
		},
	});
};
